import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, ChevronDown, ChevronUp } from "lucide-react";

const fmt = (v) => Number(v).toFixed(1).replace(".", ",");

export const NoaPendingAlert = ({ classId, reloadKey, onPick }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    api.get(`/classes/${classId}/noa-pending`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [classId, reloadKey]);
  if (!data?.total) return null;
  return (
    <div className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800" data-testid="noa-pending-alert">
      <button type="button" className="flex w-full items-center gap-2 text-left font-semibold" onClick={() => setOpen((v) => !v)} data-testid="noa-pending-toggle">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span className="flex-1" data-testid="noa-pending-count">{data.total} nota(s) do trimestre abaixo de 5,0 sem NOA lançada</span>
        {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>
      {open && (
        <ul className="mt-2 max-h-72 space-y-1 overflow-y-auto" data-testid="noa-pending-list">
          {data.items.map((it) => (
            <li key={`${it.student_id}-${it.subject_id}-${it.term_order}`}>
              <button type="button" onClick={() => onPick(it.subject_id, it.term_order)}
                className="flex w-full flex-wrap items-center gap-x-3 rounded bg-white/70 px-2 py-1.5 text-left transition-colors hover:bg-white"
                data-testid={`noa-pending-item-${it.student_id}-${it.subject_id}-${it.term_order}`}>
                <span className="font-medium text-slate-800">{it.full_name}</span>
                <span className="text-slate-500">{it.subject_name} • {it.term_order}º tri</span>
                <span className="ml-auto font-semibold text-red-600">{fmt(it.base)}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
